import ChangePassword from "views/ChangePassword";
import Interpreters from "views/Interpreters";
import Dashboard from "views/Dashboard";
import ClientType from "views/clients/Accounts";
import { AppointmentRoutes } from "views/Appointment";
import LanguageList from "views/tools/language";
import StateList from "views/tools/state";
import CityList from "views/tools/city";
import CreateAccount from "views/clients/accounts/Create";
import UpdateAccount from "views/clients/accounts/Update";
import PermissionGroups from "views/permissions/Groups";
import PermissionSubUser from "views/permissions/SubUsers";
import UpdateGroup from "views/permissions/groups/Update";
import CreateGroup from "views/permissions/groups/Create";
import VendorList from "views/clients/vendors";
import Facility from "components/type/facilities/Facility";
import Department from "components/type/departments/Departments";
import InvoicePayments from "views/InvoicePayments";
import InvoiceAppointmentDetail from "views/InvoicePayments/InvoiceApptDetail";
import PdfView from "views/InvoicePayments/PdfView";
import AllPdfView from "views/AllInvoices/PdfView";
import InvocieList from "views/AllInvoices/AllInvoices";
import ToolFacility from "views/tools/facility";
import ToolDepartment from "views/tools/department";
import IntepreterPayments from "views/Payments/InterpreterPayments";
import VendorPayments from "views/Payments/VendorPayments";
import Translation from "views/Translation/Translation";
import AddTranslatoinForm from "views/AddTranslationForm/AddTranslatoinForm";
import TranslationView from "views/Translation/TranslationView";
import ClientTranslationView from "views-main-account/ClientTranslation/ClientTranslationView";
import AddClientTranslatoinForm from "views-main-account/ClientTranslation/AddClientTranslatoinForm";
import InviteTranslators from "views/Translation/InviteTranslators";
import Reporting from "views/Reporting";

var routes = [

  {
    path: "",
    title: "Dashboard",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Dashboard />,
    layout: "/",
  },
  // {
  //   path: "appointments",
  //   title: "Appointments",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <AppointmentRoutes />,
  //   layout: "",
  // },
  // {
  //   path: "translation",
  //   title: "Translations",
  //   subRoute: false,
  //   icon: "/images/meeting-place.png",
  //   iconActive: "/images/meeting-place-active.png",
  //   component: <Translation />,
  //   layout: "/",
  // },
  // {
  //   path: "translation/view/:id",
  //   subRoute: true,
  //   component: <TranslationView />,
  //   layout: "/",
  // },
  // {
  //   path: "/translation/create",
  //   subRoute: true,
  //   component: <AddTranslatoinForm />,
  //   layout: "/",
  // },
  // {
  //   path: "clients",
  //   title: "Clients",
  //   subRoute: false,
  //   icon: "/images/meeting-place.png",
  //   iconActive: "/images/meeting-place-active.png",
  //   component: <ClientType />,
  //   layout: "",
  // },
  // {
  //   path: "clients/create",
  //   subRoute: true,
  //   component: <CreateAccount />,
  //   layout: "/admin",
  // },
  // {
  //   path: "clients/facilities/:id",
  //   subRoute: true,
  //   component: <Facility />,
  //   layout: "/admin",
  // },
  // {
  //   path: "clients/departments/:id",
  //   subRoute: true,
  //   component: <Department />,
  //   layout: "/admin",
  // },
  // {
  //   path: "clients/update/:id",
  //   subRoute: true,
  //   component: <UpdateAccount />,
  //   layout: "/admin",
  // },
  // {
  //   path: "billings",
  //   title: "Billings",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <InvoicePayments />,
  //   layout: "",
  // },
  // {
  //   path: "billings/detail/:id",
  //   subRoute: true,
  //   component: <InvoiceAppointmentDetail />,
  //   layout: "/admin",
  // },
  // {
  //   path: "billings/pdf-view/:id",
  //   subRoute: true,
  //   component: <PdfView />,
  //   layout: "/admin",
  // },
  // {
  //   path: "invoices",
  //   title: "Invoices",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <InvocieList />,
  //   layout: "",
  // },
  // {
  //   path: "invoices/pdf-view/:id",
  //   subRoute: true,
  //   component: <AllPdfView />,
  //   layout: "/admin",
  // },
  // {
  //   path: "interpreters",
  //   title: "Interpreters",
  //   icon: "/images/calendar-view.png",
  //   iconActive: "/images/calendar-view.png",
  //   component: <Interpreters />,
  //   layout: "/",
  // },
  {
    path: "vendors",
    title: "Vendors",
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <VendorList />,
    layout: "",
  },
  {
    path: "reports",
    title: "Report",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Reporting />,
    layout: "",
  },
  // {
  //   path: "interpreter-payments",
  //   title: "Interpreter Payments",
  //   icon: "/images/meeting-place.png",
  //   iconActive: "/images/meeting-place-active.png",
  //   component: <IntepreterPayments />,
  //   layout: "",
  // },
  // {
  //   path: "vendor-payments",
  //   title: "Vendor Payments",
  //   icon: "/images/meeting-place.png",
  //   iconActive: "/images/meeting-place-active.png",
  //   component: <VendorPayments />,
  //   layout: "",
  // },
  {
    path: "permissions/groups",
    title: "Groups",
    subRoute: true,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <PermissionGroups />,
    layout: "/",
  },
  {
    path: "permissions/groups/create",
    subRoute: true,
    component: <CreateGroup />,
    layout: "/admin",
  },
  {
    path: "permissions/groups/update/:id",
    subRoute: true,
    component: <UpdateGroup />,
    layout: "/admin",
  },

  {
    path: "permissions/sub-users",
    title: "Sub Users",
    subRoute: true,
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <PermissionSubUser />,
    layout: "",
  },

  // {
  //   path: "tools/city",
  //   subRoute: true,
  //   component: <CityList />,
  //   layout: "/admin",
  // },
  {
    path: "tools/state",
    subRoute: true,
    component: <StateList />,
    layout: "/admin",
  },
  {
    path: "tools/facility",
    subRoute: true,
    component: <ToolFacility />,
    layout: "/admin",
  },
  {
    path: "tools/department",
    subRoute: true,
    component: <ToolDepartment />,
    layout: "/admin",
  },
  {
    path: "tools/language",
    subRoute: true,
    component: <LanguageList />,
    layout: "/admin",
  },
  {
    path: "change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/",
  },
  {
    path: "/translation/invite-translators/:id",
    subRoute: true,
    component: <InviteTranslators />,
    layout: "/",
  },
];
export default routes;
